module.exports = __webpack_public_path__ + "img/logo.39e57768.png";